import { useDealItemPicker } from '../DealItemPicker';
import { classNames } from 'libs/react';
import { ButtonStatus } from '../DealItemPicker';
import { Button } from 'components/Button';
import { React } from 'libs/react';
import './DealItemPickerNextButton.scss';
/**
 * @component DealItemPickerNextButton
 * @since 1.0.0
 * @hidden
 */
export function DealItemPickerNextButton(props) {
    const { style, status } = props;
    const { gotoNext } = useDealItemPicker();
    if (status == ButtonStatus.Hidden) {
        return null;
    }
    const className = classNames('deal-item-picker-next-button', 'deal-item-picker-next-button--' + style, props.className);
    const disabled = status == ButtonStatus.Disabled;
    return (React.createElement("div", { className: "deal-item-picker-tool-bar-item" },
        React.createElement(Button, { className: className, style: "primary", badge: "arrow-right", label: t('Next'), disabled: disabled, onPress: gotoNext })));
}
